import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import SectionHeading from "../common/SectionHeading";
import { staffingProcess } from "../../data/talent";

export default function ProcessTimeline() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 60%", "end 60%"],
  });
  const height = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  return (
    <section className="relative px-6 py-24 lg:py-32" data-testid="process-timeline">
      <div className="mx-auto max-w-5xl">
        <SectionHeading
          eyebrow="Our Process"
          title="A proven 5-step staffing process"
          subtitle="Structured, transparent and fast — designed to put the right people on your team without the guesswork."
          testId="process"
        />

        <div ref={ref} className="relative mt-16 pl-8 lg:pl-0">
          {/* Track */}
          <div className="absolute bottom-0 left-4 top-0 w-px bg-white/10 lg:left-1/2 lg:-translate-x-1/2" />
          <motion.div
            style={{ height }}
            className="absolute left-4 top-0 w-px bg-gradient-to-b from-sky-400 to-indigo-500 lg:left-1/2 lg:-translate-x-1/2"
          />

          <div className="space-y-12">
            {staffingProcess.map((step, i) => (
              <motion.div
                key={step.step}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6 }}
                className={`relative lg:flex lg:items-center ${
                  i % 2 === 0 ? "lg:justify-start" : "lg:flex-row-reverse"
                }`}
              >
                <div className="absolute -left-[1.85rem] flex h-4 w-4 items-center justify-center lg:left-1/2 lg:-translate-x-1/2">
                  <span className="h-3 w-3 rounded-full border-2 border-sky-400 bg-ink-900" />
                </div>
                <div className="lg:w-[46%]">
                  <div className="rounded-2xl border border-white/10 bg-ink-800/50 p-7 transition-colors duration-500 hover:border-sky-400/40">
                    <div className="font-heading text-4xl font-bold text-sky-400/30">
                      {step.step}
                    </div>
                    <h3 className="mt-2 font-heading text-xl font-bold tracking-tight text-white">
                      {step.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-slate-400">
                      {step.description}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
